import React from 'react';
import { MetricExplainerIcon } from '../metrics/MetricWithExplainer';

export function MiniMetric({ label, value, color, icon: Icon, metric }) {
  return (
    <div className="flex items-center gap-2 px-2.5 py-1.5 rounded-lg" style={{ background: '#181A20', border: '1px solid #2E3240' }}>
      <Icon className="h-3 w-3" style={{ color }} />
      <div className="min-w-0">
        <div className="flex items-center gap-0.5 leading-none mb-0.5">
          <span className="text-[8px] uppercase tracking-wider text-gray-500 font-bold">{label}</span>
          {metric && <MetricExplainerIcon metric={metric} size="xs" placement="bottom" />}
        </div>
        <div className="text-[12px] font-black tabular-nums leading-none" style={{ color }}>{value}</div>
      </div>
    </div>
  );
}
